const ATTENTION_CLASS = "search-type-dropdown-attention";

const SEARCH_TYPE_DROPDOWN_IDS = [
  "input-group-dropdown-desktop",
  "input-group-dropdown-mobile",
] as const;

export function highlightSearchTypeDropdown() {
  SEARCH_TYPE_DROPDOWN_IDS.forEach((id) => {
    const el = document.getElementById(id);
    if (!el) return;

    const handleEnd = (event: AnimationEvent) => {
      if (event.target !== el) return;
      el.classList.remove(ATTENTION_CLASS);
      el.removeEventListener("animationend", handleEnd);
    };

    el.removeEventListener("animationend", handleEnd);
    el.classList.remove(ATTENTION_CLASS);
    void el.offsetWidth;
    el.addEventListener("animationend", handleEnd, { once: true });
    el.classList.add(ATTENTION_CLASS);
  });
}
